import { ClassNameProp, TestableComponentProps } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import {
   Practitioner,
   PractitionerPresentationOrder,
   PractitionerSafePresenterRenderer,
   PractitionerSafePresenterType,
   WithIdentification,
   WithSpecialties,
} from './PractitionerSafePresenter.types';
import {
   getPractitionerDisplayName,
   getPractitionerSafePresenterRenderer,
   selectPractitionerData,
} from './PractitionerSafePresenter.utils';

type PractitionerSafePresenterDataProp = WithIdentification | WithSpecialties;

type PractitionerSafePresenterRendererProp =
   | { children: PractitionerSafePresenterRenderer; type?: never }
   | { type: PractitionerSafePresenterType; children?: never };

type PractitionerSafePresenterProps = TestableComponentProps &
   ClassNameProp &
   PractitionerSafePresenterRendererProp &
   PractitionerSafePresenterDataProp & {
      practitioner: Practitioner;
      presentationOrder?: PractitionerPresentationOrder;
   };

export const PractitionerSafePresenter = (props: PractitionerSafePresenterProps): JSX.Element => {
   const searchingAllPractitionersDetailsAvailable = protectFeature('searchingAllPractitionersDetails');

   return getPractitionerSafePresenterRenderer(
      props.children,
      props.type
   )({
      testId: props.testId,
      className: props.className,
      displayName: getPractitionerDisplayName(props.practitioner, props.presentationOrder),
      withIdentification: Boolean(props.withIdentification),
      withSpecialties: Boolean(props.withSpecialties),
      ...selectPractitionerData(props.practitioner, props.withSpecialties, searchingAllPractitionersDetailsAvailable),
   });
};
